import { foodItemSchema } from "@/packages/dashboard/api/get-meals";
import { nua } from "@/packages/dashboard/nua";

export const nuaInferNutritionInfo = nua.createFn({
  prompt: `
You are an expert nutrition analyst. For each food item provided as input, determine the nutritional information for a single, standard serving. Provide the following five fields for each item.

Rules
The serving size must be a realistic amount for one person in one sitting.
All units must be metric and measurable.
Allowed units: grams, ml, piece, slice, etc.
Disallowed units: Ambiguous measures like cup, bowl, handful, etc.

Output Fields
1. Serving Unit: The most natural, measurable unit for the food item.
Examples: grams, piece, slice

2. Serving Size: A positive number representing the quantity of the chosen Serving Unit.
Example: 100 (if food item is chicken breast and unit is grams)
Example: 2 (if food item is bread and unit is slices)

3. Serving Description A plain-language description of the complete serving (combining size and unit).
Example: "100g of chicken breast", "One medium apple", "Two slices of whole wheat bread"

4. Calories (kcal) The estimated total calories (kcal) for the described serving.
5. Macronutrients (grams) The estimated grams for each of the following components in the described serving: Carbohydrates, Proteins, Fats  
  `,
  output: {
    name: "foodItemWithNutritionInfo",
    schema: foodItemSchema,
  },
});
